<template>
	<div class="">
		<base-page-heading
			title="Badges"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<BadgesTable
				@routeBadge="routeBadge"
			/>
		</div>
	</div>
</template>
